function Feedback() {
    return <h2>Feedback Page</h2>;
}

export default Feedback;
